import React from "react";

function Cricket() {
  return <h1>Cricket Page</h1>;
}

export default Cricket;
